module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Title_Page",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death by Water")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_2"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Author's_Note"
    }
  }, [_vm._v("Author’s Note and Pre-Emptive Apology")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/More_from_this_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Contact_Us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact Us")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df4e4b14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Contents.vue
// module id = 66
// module chunks = 0